webpackJsonp([192551386620669],{

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n'], ['\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    fill: #fff;\n'], ['\n    fill: #fff;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var IMG = _styledComponents2.default.img(_templateObject);
	
	var SVG = _styledComponents2.default.svg(_templateObject2);
	
	var Sponsors = function Sponsors() {
	    return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'http://tech.lifeway.com/', target: '_blank', rel: 'noopener' },
	                    _react2.default.createElement(
	                        SVG,
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 103.53 28.25' },
	                        _react2.default.createElement(
	                            'g',
	                            null,
	                            _react2.default.createElement(
	                                'title',
	                                null,
	                                'LifeWay IT'
	                            ),
	                            _react2.default.createElement('path', { d: 'M78.35 4.5h1.15v19.24h-1.15z' }),
	                            _react2.default.createElement('path', { d: 'M0 0v28.25h103.53V0zm102.37 27.1H1.16V1.15h101.21z' }),
	                            _react2.default.createElement('path', { d: 'M10.84 16.95H8.02v-6.86H6.75v7.98h4.09v-1.12zM15.86 10.09h1.27v7.98h-1.27zM24.2 14.65h2.85v-1.11H24.2v-2.33h2.89v-1.12h-4.16v7.98h1.27v-3.42zM36.8 16.95h-3.19v-2.36h3.15v-1.11h-3.15v-2.27h3.19v-1.12h-4.46v7.98h4.46v-1.12zM45.13 18.07l1.55-6.05 1.54 6.05h1.17l2.2-7.98H50.3l-1.55 6.26-1.59-6.26h-.96l-1.56 6.25-1.58-6.25h-1.29l2.16 7.98h1.2zM57.55 16.18H61l.75 1.89h1.35l-3.22-8h-1.16l-3.28 8h1.38zm1.69-4.61l1.37 3.59H57.9zM69.08 18.07h1.27v-2.83l2.5-5.15h-1.38l-1.76 3.95-1.76-3.95h-1.38l2.51 5.15v2.83zM86.25 10.09h1.27v7.98h-1.27zM94.39 18.07h1.27v-6.86h1.83v-1.12h-4.94v1.12h1.84v6.86z' })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'http://dts.edu/', target: '_blank', rel: 'noopener' },
	                    _react2.default.createElement(IMG, { src: 'img/dts.png', alt: 'Dallas Theological Seminary' })
	                )
	            )
	        )
	    );
	};
	
	exports.default = Sponsors;
	module.exports = exports['default'];

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 40em;\n  h2 + p {\n    margin-bottom: 2.5rem;\n    text-align: center;\n  }\n  div {\n    margin: 4rem auto;\n  }\n  svg, img {\n    width: 100%;\n  }\n  svg {\n    max-height: 85px;\n  }\n'], ['\n  max-width: 40em;\n  h2 + p {\n    margin-bottom: 2.5rem;\n    text-align: center;\n  }\n  div {\n    margin: 4rem auto;\n  }\n  svg, img {\n    width: 100%;\n  }\n  svg {\n    max-height: 85px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _sponsors = __webpack_require__(80);
	
	var _sponsors2 = _interopRequireDefault(_sponsors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = _styledComponents2.default.section(_templateObject);
	
	var SponsorsPage = function SponsorsPage() {
	  return _react2.default.createElement(
	    Section,
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Sponsors'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Interested in sponsoring Faith Leads Tech? Email',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:info@faithleads.tech' },
	        'info@faithleads.tech'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(_sponsors2.default, null)
	  );
	};
	
	exports.default = SponsorsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sponsors-js-198051136c903aa2c39a.js